import { BaseEntity } from "@planard/@core/base/BaseEntity";

export class Forecast extends BaseEntity {
  rows?: any[];
}
